import { FormPageInputItemNumberAttitudeScale } from 'backend';
import React, { memo } from 'react';
import { NumberPropertyAttitudeScale, NumberAttitudeScaleInput } from 'shared';
import { FormFieldInputItemProps } from '../shared';

type NumberValue = FormPageInputItemNumberAttitudeScale['number'];

type Props = FormFieldInputItemProps<
  NumberPropertyAttitudeScale,
  FormPageInputItemNumberAttitudeScale
> & {
  value: NumberValue;
};

const NUMBER_KEY: Extract<
  keyof FormPageInputItemNumberAttitudeScale,
  'number'
> = 'number';

export const NumberAttitudeScale: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    value,
    onBlur,
    className,
    errorMessages,
    displayError,
  }) => {
    const { propertyId, inputFormat } = property;
    const { scaleStart, scaleEnd, leftLabel, centerLabel, rightLabel } =
      inputFormat;
    const handleChange = (numberValue: NumberValue) => {
      /*
       * ラジオボタン変更時に随時バリデーションを実行するため、親コンポーネント内で定義している
       * handleBlurを以下に呼び出しています
       */
      onBlur(NUMBER_KEY, numberValue);
    };

    return (
      <NumberAttitudeScaleInput
        propertyId={propertyId}
        scaleStart={scaleStart}
        scaleEnd={scaleEnd}
        leftLabel={leftLabel}
        centerLabel={centerLabel}
        rightLabel={rightLabel}
        value={value}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        design={design}
        className={className}
      />
    );
  },
);
